import { createRouter, createWebHistory } from 'vue-router';
import Form from '../Form.vue';
import Learn from '../Learn.vue';
import Confirmation from "../Confirmation.vue";
import StatusUpdate from "../StatusUpdate";

const routes = [
    {
        path: '/',
        name: 'Form',
        component: Form,
    },
    {
        path: '/learn',
        name: 'Learn',
        component: Learn,
    },
    {
        path: '/confirmation',
        name: 'Confirmation',
        component: Confirmation,
    },
    {
        path: '/:referralId/:partnerBankUuid/confirmation/:status',
        name: 'StatusUpdate',
        component: StatusUpdate
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { top: 0 };  // Always scroll to top
    },
});

export default router;
